@let t = toast();

@if (t.type === 'loading') {
  <div class="shrink-0" [class]="colors().icon" data-icon>
    <span
      class="m-0.5 block size-4 animate-spin rounded-full border-2 border-gray-200 border-t-current"
      aria-hidden="true"
      data-loader
    ></span>
  </div>
} @else if (icon(); as path) {
  <div class="shrink-0" [class]="colors().icon" data-icon>
    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" [attr.d]="path" />
    </svg>
  </div>
}

<div #content class="min-w-0 flex-1 space-y-1" data-content>
  <div class="font-medium" data-title>{{ t.title }}</div>
  @if (t.description) {
    <div [class]="colors().description" data-description>{{ t.description }}</div>
  }
</div>

@if (t.cancel || t.action) {
  <div class="flex shrink-0 items-center gap-2 self-center">
    @if (t.cancel; as cancel) {
      <button
        type="button"
        class="focus-visible:outline-primary-500 rounded-md bg-gray-100 px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-200 focus-visible:outline-2 focus-visible:outline-offset-2"
        data-cancel
        (click)="onCancel($event, cancel)"
      >
        {{ cancel.label }}
      </button>
    }
    @if (t.action; as action) {
      <button
        type="button"
        class="bg-primary-600 hover:bg-primary-700 focus-visible:outline-primary-500 rounded-md px-2.5 py-1.5 text-xs font-medium text-white focus-visible:outline-2 focus-visible:outline-offset-2"
        data-action
        (click)="onAction($event, action)"
      >
        {{ action.label }}
      </button>
    }
  </div>
}

@if (showCloseButton()) {
  <button
    type="button"
    class="focus-visible:outline-primary-500 -m-1.5 shrink-0 rounded-md p-1.5 opacity-60 hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-2"
    data-close-button
    [attr.aria-label]="defaults().closeButtonAriaLabel"
    (click)="dismiss()"
  >
    <svg class="size-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" [attr.d]="closeIcon" />
    </svg>
  </button>
}
